module.exports = __webpack_public_path__ + "static/media/logo_weedigital.43469891.svg";